import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrdersPaymentRequest } from '~/lazy/payments/pages/new-payment/models/ordersPaymentRequest';
import { StatusScreenTypeEnum } from '@qvs/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { StatusScreenComponent } from '~/shared/components/status-screen/status-screen.component';
import { RequestContactComponent } from '~/shared/components/request-contact/request-contact.component';

@Component({
  selector: 'qvs-validate-payment-order-request-failed',
  templateUrl: './validate-payment-order-request-failed.component.html',
  styleUrls: ['./validate-payment-order-request-failed.component.scss'],
  standalone: true,
  imports: [NgSwitch, NgSwitchCase, NgSwitchDefault, TranslatePipe, StatusScreenComponent, RequestContactComponent]
})
export class ValidatePaymentOrderRequestFailedComponent {
  @Input() ordersPaymentRequest: OrdersPaymentRequest;
  @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();

  readonly statusScreenType = StatusScreenTypeEnum;

  close() {
    this.closed.emit();
  }
}
